import React, { useState } from 'react';
import { callApi } from '../api';
import ImageUploader from './ImageUploader';

const GaleriFormu = ({ kulup, onSave, onCancel }) => {
    const [resimURL, setResimURL] = useState('');
    const [aciklama, setAciklama] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!resimURL) {
            setError('Lütfen bir resim yükleyin.');
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            const kulupQuery = kulup?.kulupID ? `?kulupID=${kulup.kulupID}` : '';
            await callApi(`/galeri${kulupQuery}`, 'POST', { resimURL, aciklama, kulupID: kulup?.kulupID });
            onSave();
        } catch (err) {
            setError(err.message || 'Resim kaydedilemedi.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="modern-form-wrapper">
            <div className="drag-handle-pill"></div>

            <div className="form-header flex items-center justify-between pb-3 mb-3 border-b">
                <h3 className="text-xl font-bold text-gray-800 m-0">
                    Galeriye Resim Ekle
                </h3>
                <button
                    type="button"
                    onClick={onCancel}
                    className="w-8 h-8 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 flex items-center justify-center font-bold text-lg transition-colors border-none cursor-pointer"
                    aria-label="Kapat"
                >
                    ✕
                </button>
            </div>

            {error && <div className="error-message p-3 bg-red-50 text-red-600 rounded-xl text-sm mb-4 border border-red-200">{error}</div>}

            <form onSubmit={handleSubmit} className="modern-form space-y-4">
                <div className="form-card-section p-4 bg-gray-50 border border-gray-200 rounded-2xl">
                    <label className="form-label font-semibold text-sm mb-2 block text-gray-700">Yüklenecek Görsel *</label>
                    <ImageUploader
                        currentUrl={resimURL}
                        onUploadComplete={(url) => setResimURL(url)}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label font-semibold text-sm mb-1 block text-gray-700">Açıklama / Başlık (Opsiyonel)</label>
                    <input
                        type="text"
                        placeholder="Örn: Etkinlik Anısı, Açılış Töreni"
                        value={aciklama}
                        onChange={(e) => setAciklama(e.target.value)}
                        className="form-input w-full p-3 border border-gray-200 rounded-xl"
                    />
                </div>

                <div className="form-sticky-actions">
                    <button type="button" onClick={onCancel} disabled={isLoading} className="cancel-button">
                        İptal
                    </button>
                    <button type="submit" disabled={isLoading || !resimURL} className="submit-button">
                        {isLoading ? 'Kaydediliyor...' : 'Kaydet'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default GaleriFormu;
